module.exports = __webpack_public_path__ + "img/12.5e5c8b11.jpg";